import uiConfig from 'Models/uiConfig/uiConfig';

const { edgeRange, centralRange, disableDelimiters } = uiConfig.pagination;

export type PaginationButtonType = 'delimiter' | 'next' | 'nextStub' | 'page' | 'prev' | 'prevStub';

type PageButtonProps = {
  type: Extract<PaginationButtonType, 'page'>;
  key: string;
  pageNumber: number;
  totalPages: number;
};

type NavigationButtonProps = {
  type: Extract<PaginationButtonType, 'next' | 'prev'>;
  key: string;
  pageNumber: number;
};

type StaticButtonProps = {
  type: Extract<PaginationButtonType, 'delimiter' | 'nextStub' | 'prevStub'>;
  key: string;
  pageNumber?: undefined;
  totalPages?: undefined;
};

export type PaginationButtonProps = NavigationButtonProps | PageButtonProps | StaticButtonProps;

function makeButtonProps(
  activePageNumber: number,
  lastPageNumber: number,
  withPrevNextStubs?: boolean,
): PaginationButtonProps[] {
  const buttonProps: PaginationButtonProps[] = [];

  if (activePageNumber > 0) {
    buttonProps.push({ type: 'prev', key: 'prev', pageNumber: activePageNumber - 1 });
  } else if (withPrevNextStubs) {
    buttonProps.push({ type: 'prevStub', key: 'prevStub' });
  }

  for (let pageNumber = 0; pageNumber < lastPageNumber + 1; pageNumber++) {
    if (pageNumber < edgeRange) {
      buttonProps.push(pageProps(pageNumber, lastPageNumber));
    } else if (pageNumber === edgeRange && pageNumber < activePageNumber) {
      if (pageNumber >= activePageNumber - centralRange - 1) {
        buttonProps.push(pageProps(pageNumber, lastPageNumber));
      } else {
        if (!disableDelimiters) {
          buttonProps.push(delimiterProps('first'));
        }

        pageNumber = activePageNumber - centralRange - 1;
      }
    } else if (
      pageNumber >= activePageNumber - centralRange &&
      pageNumber <= activePageNumber + centralRange
    ) {
      buttonProps.push(pageProps(pageNumber, lastPageNumber));
    } else if (pageNumber === activePageNumber + centralRange + 1) {
      if (pageNumber >= lastPageNumber - edgeRange) {
        buttonProps.push(pageProps(pageNumber, lastPageNumber));
      } else {
        if (!disableDelimiters) {
          buttonProps.push(delimiterProps('first'));
        }

        pageNumber = lastPageNumber - edgeRange;
      }
    } else {
      buttonProps.push(pageProps(pageNumber, lastPageNumber));
    }
  }

  if (activePageNumber < lastPageNumber) {
    buttonProps.push({ type: 'next', key: 'next', pageNumber: activePageNumber + 1 });
  } else if (withPrevNextStubs) {
    buttonProps.push({ type: 'nextStub', key: 'nextStub' });
  }

  return buttonProps;
}

function pageProps(pageNumber: number, totalPages: number): PageButtonProps {
  return { type: 'page', key: pageNumber.toString(), pageNumber, totalPages: totalPages + 1 };
}

function delimiterProps(key: string): PaginationButtonProps {
  return { type: 'delimiter', key: `delimiter ${key}` };
}

export { makeButtonProps, pageProps };
